import { Video, Home, CalendarDays, FileSignature, FolderLock, Bot, Stethoscope } from "lucide-react";

const MAP = { Video, Home, CalendarDays, FileSignature, FolderLock, Bot, Stethoscope };

export function DeptIcon({ name, className = "h-4 w-4" }) {
  const I = MAP[name] || Stethoscope;
  return <I className={className} />;
}

export const ICON_NAMES = Object.keys(MAP);
